// extracted by mini-css-extract-plugin
export var container = "_gh-0";
export var content = "_gh-3";
export var customerTitle = "_gh-4";
export var empty = "_gh-5";
export var gray = "_gh-6";
export var header = "_gh-7";
export var info = "_gh-8";
export var loading = "_gh-2";
export var loadingCard = "_gh-9";
export var oneLine = "_gh-a";
export var personName = "_gh-e";
export var pillContainer = "_gh-b";
export var selected = "_gh-1";
export var text = "_gh-c";
export var twoLines = "_gh-d";
export var unread = "_gh-f";
export var unreadIndicator = "_gh-g";